export default __webpack_public_path__ + "static/media/B96662DD-00.51f9966b.png";